import { put, takeEvery, all, delay, select, call, takeLeading } from 'redux-saga/effects';
import { getUser, updateUserData } from 'api/neway';

// refreshes user data every 30 seconds if the user isn't verified
// we do this to actively detect that a user verified
// hopefully this creates a good experience for our users
function* updateUserIfNotVerified({ payload: { user } }) {
    if (user.emailVerified) return null;
    yield delay(30 * 1000);

    const newUser = yield getUser();

    yield put({ type: 'USER_UPDATED', payload: { user: newUser } });
}

function* updateUserAge({ payload }) {
    const user = yield select(state => state.user);
    if (user.data?.basic?.birthday) return;
    const cpr = payload.profil? payload.profil.cprNr.split('-')[0]: payload.sourceResponse.CPR;
    const day = cpr.substr(0, 2);
    const month = cpr.substr(2, 2) - 1;
    const year = cpr.substr(4, 2);
    const century = year >= '00' && year <= '10' ? '20' : '19';
    const birthday = new Date(`${century}${year}`, month, day).toISOString().slice(0, 10);

    const newUser = yield call(updateUserData, 'basic', { birthday });
    yield put({ type: 'USER_UPDATED', payload: { user: newUser } });
}
function* updateBudget({ payload: { id, content, fileType } }) {
    if(fileType === 'BudgetFile'){
        const user = yield call(updateUserData, 'budget', { data: content.sourceResponse.budget, type: 'uniify', uniifyUserId: id });
        yield put({ type: 'USER_UPDATED', payload: { user } });
    }

}
export default function* userSaga() {
    yield all([takeLeading('USER_UPDATED', updateUserIfNotVerified)]);
    yield all([takeEvery('PI_SCRAPE_SUCCESS', updateUserAge)]);
    yield all([takeEvery('FILE_KREDITDATA_SAVE_REQUEST', updateBudget)]);
}
